import React__default, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const setElementScrollLeft = (element, value)=>{
    element.scrollLeft = value;
};
const Tabs = ({ children , onChange , activeTabIndex , variant ='primary' ,  })=>{
    const tabsRef = useRef(null);
    const activeTabRef = useRef(null);
    const [isScrolling, setIsScrolling] = useState(false);
    useEffect(()=>{
        const setScrolling = (current)=>{
            const { offsetWidth , scrollWidth  } = current;
            offsetWidth < scrollWidth ? setIsScrolling(true) : setIsScrolling(false);
        };
        const onResize = ()=>{
            if (!tabsRef.current) {
                return;
            }
            setScrolling(tabsRef.current);
        };
        if (tabsRef.current) {
            setScrolling(tabsRef.current);
            window.addEventListener('resize', onResize);
            activeTabRef.current && setElementScrollLeft(tabsRef.current, activeTabRef.current.offsetLeft);
        }
        return ()=>window.removeEventListener('resize', onResize)
        ;
    }, [
        tabsRef.current
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "tabs__wrapper"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: classnames(`tabs tabs--${variant}`, {
            'tabs--scrolling': isScrolling
        }),
        ref: tabsRef
    }, React__default.Children.map(children, (child, index)=>{
        if (/*#__PURE__*/ React__default.isValidElement(child)) {
            return /*#__PURE__*/ React__default.cloneElement(child, {
                onClick: ()=>{
                    onChange && onChange(index);
                    child.props.onClick && child.props.onClick();
                },
                isActive: activeTabIndex === index,
                variant,
                ref: activeTabIndex === index ? activeTabRef : undefined
            });
        }
    }), isScrolling && /*#__PURE__*/ React__default.createElement(Icon, {
        className: "tabs__scroll-icon",
        name: "chevron-right"
    })));
};
var Tabs$1 = Tabs;

export { Tabs$1 as default, setElementScrollLeft };
//# sourceMappingURL=Tabs.js.map
